<template>
  <div class="packageprepare">
    <div class="listItembox">
      <Row type="flex" v-if="pageTotal == 0" style="text-align: center;">
        <Col span="24"><img class="emptyImg" src="/static/images/empty.png" alt=""></Col>
        <Col span="24" style="margin-top:20px;">暂时没有相关内容～</Col>
      </Row>
      <div class="listItem" v-else v-for="(item,index) in packageList" :key="index" style="margin-bottom:15px;">
          <div class="avatar">
              {{index+1}}
          </div>
          <div class="description">
              <div class="itemTitle">{{item.filename}}</div>
              <div class="itemPlace">
                  <div class="itemAuthor">来源:未来课堂</div>
              </div>
          </div>
      </div>
    </div>

    <div class="page" v-if="pageTotal !=0">
        <Page :total="pageTotal" :page-size='12' @on-change="changePage"/>
    </div>
  </div>
</template>

<script>
  import api from '../../utils/api.js';
  import bus from '../../assets/eventBus/enentBus.js';
  export default {
    name: 'PrepareVideo',
    props:{
      prepareData: { //同步资源
        type: Object,
        defalut: {}
      }
    },
    data() {
      return {
        pageTotal:null,
        urlHttp:'/testIp',
        packageList:null,
        imgurl:'https://qcban.aixuetang.com/res/',              //微课图片地址  线上域名
      }
    },
    watch: {
      prepareData: {
          handler: function(newVal,oldVal) {
            this.getData(1);
          },
          deep: true
        }
    },
    mounted() {
      const that = this;
      this.getData(1)
    },
    methods:{
      //获取资料
      getData(pageNo){
        const that = this;
          const url =  '/axt-resources/package_prepare/pageMaterial';    //课件
         // console.log(this.prepareData,"prepareData")
          const params = {
              packageCourseId:this.prepareData.packageId,
              packageChapterId:this.prepareData.chapterId,
              packageLectureId:this.prepareData.lectureId,
              packageSectionId:this.prepareData.sectionId,
              useType: 0,
              orderBys: [{
              		direction: 'asc',
              		field: 'sort_id'
              }],
              materialType: this.prepareData.type-3,
              showUseType: true,
              pageNo: pageNo,
              pageSize: 12
          };
          //console.log(params,"99999")
          api.postFormAPI(url,params).then(res => {
              //console.log(res)
              that.pageTotal = res.data.data.total;
              that.packageList = res.data.data.rows;
          }).catch(err => {
              console.log(err)
          })
      },
      changePage(page){
          const that = this;
          this.getData(page);
      },
    }
  }

</script>

<style>
  .srContent{
     width:69%;
     margin-left:3%;
  }
  .srContent .ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab-active{
      color: #3683FF;
  }
  .srContent .ivu-list-item-meta-content{
      text-align: left;
  }
  .srContent .downLoadBtn{
      width:75px;
      height: 32px;
      border-radius: 16px;
      font-size: 14px;
  }
  .packageprepare .listItem{
      border-bottom: 2px solid #F2F2F2;
      padding: 15px 15px 15px 0;
      background: #F3F5FA;
      border-radius: 10px;
      margin-bottom: 20px;
      line-height: 1.8;
      display: flex;
      flex-direction: row;
      height: auto;
  }
  .packageprepare .avatar{
      flex:1;
      font-size: 34px;
      font-weight: 500;
      text-align: center;
      color: #4357F2;
  }
  .avatar img{
      width:65px;
      height:76px;
  }
  .description{
      flex:10;
      display: flex;
      flex-direction: column;
      text-align: left;
  }
  .description .itemTitle{
      font-size: 16px;
      font-weight: 600;
      color: #34495E;
      line-height: 30px;
  }
  .description .itemPlace, .description .itemNumber{
      display: flex;
      flex-direction: row;
      font-size: 14px;
      font-weight: 500;
      color:#9a9a9a;
      line-height: 25px;
  }
  .description .itemPlace .itemAuthor{
      padding-right: 35px;
  }
  .description .itemTime,.description .itemViews{
      padding-right: 35px;
      display: table-cell;
      vertical-align: middle;
  }
  .description .itemViews img{
      width:14px;
      height: 14px;
  }
  .itemDownLoad{
      flex:1;
      line-height: 108px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PrepareDetail/PreparePpt.vue